export type AudienceFilterVariant = 'inclusion' | 'exclusion';

/**
 * Per-variant Tailwind classes used to colour-code the Inclusions (green/teal)
 * and Exclusions (red) sections of the audience builder. The section sits in a
 * neutral grey block; the accent colour (heading, AND line, action links) is
 * what distinguishes the variants. Shared between AudienceFilterField (section
 * chrome) and OrFilterField (filter rows).
 */
export const AUDIENCE_FILTER_VARIANT_STYLES: Record<
	AudienceFilterVariant,
	{
		/** Section heading text colour. */
		heading: string;
		/** Colour of the line behind the AND separator. */
		line: string;
		/** Text colour for the "+ OR" / "+ AND" action links. */
		actionLink: string;
	}
> = {
	inclusion: {
		heading: 'admin:text-teal-800',
		line: 'admin:bg-green-600',
		actionLink: 'admin:text-teal-700 admin:hover:text-teal-900',
	},
	exclusion: {
		heading: 'admin:text-red-800',
		line: 'admin:bg-red-300',
		actionLink: 'admin:text-red-700 admin:hover:text-red-900',
	},
};
